// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"7218f9fb","455":"d84a77af","551":"d591b3b2","857":"07cdb333","977":"6a7f6471"}[chunkId] + ".chunk.js";
};